import * as React from 'react';
import { observer } from 'mobx-react';
import BackgroundImage from '@src/components/background-image';
import cx from 'classnames';
import Link from '@src/components/link';
import BaseSwiperStore from '@src/components/swiper/base-swiper';
import aos from '@src/utils/aos';
const styles = require('./index.less');

const School = ({ store }) => {
  store.use();

  return (
    <React.Fragment>
      <div className="main-layer-62" {...aos.FADE_UP()} />
      <div className="main-group-26" data-name="门派">
        <div className="main-group-27" data-name="内容">
          {store.schoolList?.length > 0 && (
            <BaseSwiperStore store={store.schoolBaseSwiperStore}>
              {store.schoolList.map((item, index) => {
                return (
                  <div className="main-group-32" key={index}>
                    <div {...aos.FADE_UP()} data-aos-delay="200">
                      <div className={cx('main-layer-91')}>
                        <BackgroundImage src={item.bg_img[0]?.url} />
                      </div>
                    </div>
                    <div {...aos.FLIP_UP()}>
                      <div className={cx('weidutu', `weidutu-${item.title}`)}>
                        <BackgroundImage src={item.stats_radar_chart[0]?.url} />
                      </div>
                    </div>

                    <div {...aos.FADE_LEFT()}>
                      <div className={cx('zhuanwu', `zhuanwu-${item.title}`)}>
                        <BackgroundImage src={item.weapon_illustration[0]?.url} />
                      </div>
                    </div>

                    <div {...aos.FADE_LEFT()}>
                      <div className={cx('shiju', `shiju-${item.title}`)}>
                        <BackgroundImage src={item.name_intro_image[0]?.url} />
                      </div>
                    </div>
                    <div data-aos-delay="200" {...aos.FLIP_RIGHT()}>
                      <div className={cx('biaoti', `biaoti-${item.title}`)}>
                        <BackgroundImage src={item.title_img[0]?.url} />
                      </div>
                    </div>

                    <div className={cx('qianjing', `qianjing-${item.title}`)}>
                      <BackgroundImage src={item.fore_ground[0]?.url} className="qianjingBg" />
                    </div>
                    <div className="main-layer-109" data-name="播放按钮" onClick={() => store.playVideo(item)} />
                  </div>
                );
              })}
            </BaseSwiperStore>
          )}
        </div>

        <div className="main-group-33" data-name="人物切换" {...aos.FLIP_UP()}>
          {/*<div className="main-layer-98" />*/}
          <div className="main-group-35" data-name="未选中">
            {store.schoolList?.length > 0 && (
              <BaseSwiperStore store={store.schoolTabBaseSwiperStore}>
                {store.schoolList.map((item, index) => {
                  return (
                    <Link
                      key={index}
                      className={cx('icon')}
                      onClick={() => {
                        store.select(index);
                      }}
                    >
                      <BackgroundImage className={cx('icon-inner', 'icon-inner-unselected')} src={item.carousel_icon_unselected[0]?.url} />
                      <BackgroundImage className={cx('icon-inner', 'icon-inner-selected')} src={item.carousel_icon_selected[0]?.url} />
                      {/*<BackgroundImage*/}
                      {/*  className={cx(store.activeIndex === index ? 'icon-inner-active' : 'icon-inner')}*/}
                      {/*  src={store.activeIndex === index ? require('./images/icon-active.png') : require('./images/icon-default.png')}*/}
                      {/*/>*/}
                    </Link>
                  );
                })}
              </BaseSwiperStore>
            )}
          </div>
          <Link
            className="school-next-btn"
            onClick={() => {
              store.schoolTabBaseSwiperStore.goNext();
            }}
          />
          <Link
            className="school-prev-btn"
            onClick={() => {
              store.schoolTabBaseSwiperStore.goPrev();
            }}
          />
        </div>
      </div>

      <div className="main-layer-110" {...aos.FADE_UP()} />
    </React.Fragment>
  );
};

export default observer(School);
